import { Component } from "@angular/core";
import { LoadingBarService } from '@ngx-loading-bar/core';


@Component({
  selector: "loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent {

  totalLoader: number = 0;

  constructor(
    public loadingBarService: LoadingBarService,
  ) {

    this.onGet();
  }


  onGet(): void {
    this.loadingBarService.value$.subscribe((resp) => {
      this.totalLoader = resp;
    });
  }
}
